/* =============================================================================
 * M.M.LaFleur — mobile nav drawer relocation.
 *
 * The drawer markup lives inside mm_header.liquid, nested in .mm-header-root,
 * which Platter wraps in <header class="header-sections-container transition-all">
 * with an `initLayoutEffects` hook. That wrapper takes a transform, and a
 * transformed ancestor becomes the containing block for `position: fixed`
 * descendants — so the drawer was never sized to the viewport. It was trapped
 * inside the header's own ~110px box and clipped to it.
 *
 * That produced both reported symptoms at once: no panel slid in, and a second
 * wordmark "suddenly appeared" over the announcement bar — the drawer opening
 * correctly, but with only its head strip visible inside the header's box.
 *
 * No CSS can escape a transformed ancestor, and mm_header.liquid is the one
 * file this project avoids rewriting through the API. So the drawer is moved
 * to <body> at runtime instead, where `position: fixed; inset: 0` means the
 * viewport again.
 *
 * Nothing else needs to change: mm-editorial.js resolves the drawer with
 * document.querySelector("[data-mm-drawer]") and handles clicks by delegation
 * from document, so both keep working from the new location. Barba only swaps
 * <main>, so a single move on load holds for the session.
 * ========================================================================== */

(function () {
  "use strict";

  function relocate() {
    var drawer = document.querySelector("[data-mm-drawer]");
    if (!drawer) return;
    if (drawer.parentElement === document.body) return;

    /* .mm-scope was inherited from .mm-header-root and is lost on the move.
       Re-apply it so the drawer keeps the brand type stack and the button
       styling it was written against. mm-tune.css section 19 cancels the
       opaque background .mm-scope would otherwise paint across the viewport. */
    drawer.classList.add("mm-scope");

    document.body.appendChild(drawer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", relocate);
  } else {
    relocate();
  }

  /* The theme editor re-renders the header section on every settings change,
     which puts a fresh drawer back inside it. */
  document.addEventListener("shopify:section:load", relocate);
}());
